import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocaleFormatService } from 'src/core/services';
import { LanguageStore } from 'src/core/stores';

@Pipe({
  name: 'localeCurrency',
  standalone: true,
  pure: false,
})
export class LocaleCurrencyPipe implements PipeTransform {
  private readonly localeFormatService = inject(LocaleFormatService);
  private readonly languageStore = inject(LanguageStore);

  transform(
    value: number | null | undefined,
    currencyCode: string = 'EUR',
    currencyDisplay: 'symbol' | 'code' | 'name' | 'narrowSymbol' = 'symbol',
    currencyFormatOptions: Omit<
      Intl.NumberFormatOptions,
      'style' | 'currency' | 'currencyDisplay'
    > = {},
  ): string {
    void this.languageStore.locale();
    return this.localeFormatService.formatCurrency(
      value,
      currencyCode,
      currencyDisplay,
      currencyFormatOptions,
    );
  }
}
